(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_timezone"] && !Shopify.designMode) return;
  try {
    class TimezoneDisplay extends HTMLElement {
    constructor() {
      super();
      this.timezone = this.dataset.timezone;
      this.timezoneAbbr = this.dataset.timezoneAbbr;
      this.timeValue = this.querySelector('.timezone__time-value');
      this.timeZone = this.querySelector('.timezone__time-zone');
    }

    connectedCallback() {
      this.updateTime();
      this.interval = setInterval(() => this.updateTime(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateTime() {
      try {
        const now = new Date();

        // Format time (HH:MM)
        const timeFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timezone,
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        this.timeValue.textContent = timeFormatter.format(now);
        this.timeZone.textContent = this.timezoneAbbr || '---';
      } catch (err) {
        console.error('Failed to update timezone:', err);
        this.timeValue.textContent = '--:--';
        this.timeZone.textContent = '---';
      }
    }
  }

  if (!customElements.get('timezone-display')) {
    customElements.define('timezone-display', TimezoneDisplay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-banner"] && !Shopify.designMode) return;
  try {
    class CopyToClipboard extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.value = this.dataset.value;
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', () => this.copyToClipboard());
      }
    }

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.value);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  }

  if (!customElements.get('copy-to-clipboard')) {
    customElements.define('copy-to-clipboard', CopyToClipboard);
  }

  // Video hover functionality (desktop only)
  document.addEventListener('DOMContentLoaded', () => {
    const footerBanners = document.querySelectorAll('.footer-banner');

    footerBanners.forEach(banner => {
      const content = banner.querySelector('.footer-banner__content');
      const video = banner.querySelector('.footer-banner__video-background video');

      if (video && content && window.matchMedia('(min-width: 1025px)').matches) {
        let isPlaying = false;
        let isTransitioning = false;
        let isVideoReady = false;

        // Ensure video is loaded
        const ensureVideoReady = () => {
          return new Promise((resolve) => {
            if (video.readyState >= 3) {
              // HAVE_FUTURE_DATA or greater
              resolve();
            } else {
              video.addEventListener('canplay', () => resolve(), { once: true });
              video.load();
            }
          });
        };

        const checkAndPlay = async () => {
          if (isPlaying || isTransitioning) return;

          isTransitioning = true;

          if (!isVideoReady) {
            await ensureVideoReady();
            isVideoReady = true;
          }

          // Check if still hovering after async wait
          if (!content.matches(':hover')) {
            isTransitioning = false;
            return;
          }

          video.currentTime = 0;

          try {
            await video.play();
            isPlaying = true;
          } catch (err) {
            console.error('Video play failed:', err);
          } finally {
            isTransitioning = false;
          }
        };

        const checkAndPause = () => {
          if (isTransitioning) return;

          // Use requestAnimationFrame to ensure we check after event propagation
          requestAnimationFrame(() => {
            const isHovering = content.matches(':hover');

            if (!isHovering && isPlaying && !isTransitioning) {
              isPlaying = false;
              video.pause();
            }
          });
        };

        content.addEventListener('mouseenter', checkAndPlay);
        content.addEventListener('mouseleave', checkAndPause);

        // Extra safety: pause on any mouse movement outside the content box
        document.addEventListener('mousemove', (e) => {
          if (isPlaying && !isTransitioning) {
            const rect = content.getBoundingClientRect();
            const isInsideContent = (
              e.clientX >= rect.left &&
              e.clientX <= rect.right &&
              e.clientY >= rect.top &&
              e.clientY <= rect.bottom
            );

            if (!isInsideContent) {
              isPlaying = false;
              video.pause();
            }
          }
        });

        // Preload video on page load
        ensureVideoReady().then(() => {
          isVideoReady = true;
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-carousel"] && !Shopify.designMode) return;
  try {
    class P3CarouselElement extends HTMLElement {
    constructor() {
      super();
      this.splideInstance = null;
      this.splideLoaded = false;
      this._progressResizeHandler = null;
      this._hoverScrollLastTime = 0;
      this._hoverScrollThrottle = 800;
    }

    connectedCallback() {
      this.loadSplide()
        .then(() => this.initCarousel())
        .catch(() => {
          this.classList.add('p3-carousel--load-error');
        });
    }

    loadSplide() {
      return new Promise((resolve, reject) => {
        // Check if Splide is already loaded
        if (typeof Splide !== 'undefined') {
          this.splideLoaded = true;
          resolve();
          return;
        }

        // Check if script is already being loaded
        const existingScript = document.querySelector('script[src*="splide"]');
        if (existingScript) {
          existingScript.addEventListener('load', () => {
            this.splideLoaded = true;
            resolve();
          });
          existingScript.addEventListener('error', () => reject(new Error('Splide script failed to load')));
          return;
        }

        // Load CSS
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
        link.onerror = () => reject(new Error('Splide CSS failed to load'));
        document.head.appendChild(link);

        // Load JS
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.onload = () => {
          this.splideLoaded = true;
          resolve();
        };
        script.onerror = () => reject(new Error('Splide script failed to load'));
        document.head.appendChild(script);
      });
    }

    initCarousel() {
      if (!this.splideLoaded || typeof Splide === 'undefined') {
        console.error('P3 Carousel: Splide not loaded');
        return;
      }

      const splideElement = this.querySelector('.splide');
      if (!splideElement) {
        console.error('P3 Carousel: .splide element not found');
        return;
      }

      const splideList = splideElement.querySelector('.splide__list');
      if (!splideList) {
        console.error('P3 Carousel: .splide__list not found');
        return;
      }

      // Wrap each child element in a splide__slide li (filter out text nodes, comments, and video overlays)
      const children = Array.from(splideList.children).filter(child =>
        child.nodeType === 1 &&
        !child.classList.contains('splide__slide') &&
        !child.classList.contains('p3-video-overlay') &&
        child.tagName !== 'SCRIPT' &&
        child.tagName !== 'STYLE'
      );
      children.forEach(child => {
        const slide = document.createElement('li');
        slide.className = 'splide__slide';
        child.parentNode.insertBefore(slide, child);
        slide.appendChild(child);
      });

      const slides = splideElement.querySelectorAll('.splide__slide');
      const desktopSlides = parseInt(this.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(this.dataset.mobileSlides) || 1;
      const desktopPeek = parseInt(this.dataset.desktopPeek) || 0;
      const mobilePeek = parseInt(this.dataset.mobilePeek) || 0;
      const showPagination = this.dataset.showPagination === 'true';

      const isDesktop = window.innerWidth >= 750;

      const config = {
        type: 'loop',
        perMove: 1,
        gap: '20px',
        speed: 450,
        pagination: showPagination,
        arrows: false,
        fixedWidth: isDesktop ? '420px' : '250px',
        fixedHeight: isDesktop ? '605px' : '424.48px',
        perPage: isDesktop ? desktopSlides : mobileSlides,
        breakpoints: {
          749: {
            fixedWidth: '250px',
            fixedHeight: '424.48px',
            perPage: mobileSlides,
            gap: '20px',
          }
        }
      };

      if (desktopPeek > 0) {
        config.padding = { right: `${desktopPeek}%` };
      }
      if (mobilePeek > 0) {
        config.breakpoints[749].padding = { right: `${mobilePeek}%` };
      }

      try {
        this.splideInstance = new Splide(splideElement, config);
        this.splideInstance.mount();

        // Equalize heights after mount
        requestAnimationFrame(() => {
          this.equalizeHeights();
        });

        if (showPagination) {
          this.setupMobileProgress();
        }

        this.setupHoverScroll();

        let resizeTicking = false;
        window.addEventListener('resize', () => {
          if (resizeTicking) return;
          resizeTicking = true;
          requestAnimationFrame(() => {
            this.equalizeHeights();
            resizeTicking = false;
          });
        }, { passive: true });
      } catch (error) {
        console.error('P3 Carousel: Error mounting', error);
      }
    }

    setupHoverScroll() {
      const leftZone = this.querySelector('[data-carousel-hover="left"]');
      const rightZone = this.querySelector('[data-carousel-hover="right"]');
      if (!leftZone || !rightZone || !this.splideInstance) return;

      const onMove = (direction) => {
        const now = Date.now();
        if (now - this._hoverScrollLastTime < this._hoverScrollThrottle) return;
        this._hoverScrollLastTime = now;
        requestAnimationFrame(() => {
          if (!this.splideInstance) return;
          if (direction === 'left') this.splideInstance.go('<');
          else this.splideInstance.go('>');
        });
      };

      leftZone.addEventListener('mousemove', () => onMove('left'), { passive: true });
      rightZone.addEventListener('mousemove', () => onMove('right'), { passive: true });
    }

    setupMobileProgress() {
      const progress = this.querySelector('[data-carousel-progress]');
      const thumb = this.querySelector('[data-carousel-progress-thumb]');
      const splideList = this.querySelector('.splide__list');
      const splideTrack = this.querySelector('.splide__track');
      if (!progress || !thumb || !this.splideInstance || !splideList || !splideTrack) return;

      const updateFromIndex = () => {
        const trackWidth = progress.clientWidth;
        if (trackWidth <= 0) return;

        const end = this.splideInstance.Components?.Controller?.getEnd?.();
        const pageCount = typeof end === 'number' ? end + 1 : 1;

        const thumbWidth = Math.min(trackWidth, Math.round(trackWidth * (153 / 335)));
        thumb.style.width = `${thumbWidth}px`;

        const maxTranslate = Math.max(0, trackWidth - thumbWidth);
        const pageIndex = Math.max(0, Math.min(this.splideInstance.index || 0, pageCount - 1));
        const step = pageCount > 1 ? maxTranslate / (pageCount - 1) : 0;
        thumb.style.transform = `translateX(${Math.round(step * pageIndex)}px)`;
      };

      const updateFromTrackPosition = () => {
        const trackWidth = progress.clientWidth;
        if (trackWidth <= 0) return;

        const listWidth = splideList.scrollWidth;
        const trackVisibleWidth = splideTrack.clientWidth;
        const maxScroll = Math.max(0, listWidth - trackVisibleWidth);
        if (maxScroll <= 0) return;

        const style = window.getComputedStyle(splideList);
        const matrix = style.transform;
        let tx = 0;
        if (matrix && matrix !== 'none') {
          const m = matrix.match(/matrix\(([^)]+)\)/);
          if (m) {
            const parts = m[1].split(',').map(function (n) { return parseFloat(n.trim()); });
            if (parts.length >= 6) tx = parts[4];
            else if (parts.length >= 2) tx = parts[0];
          }
        }
        const progressRatio = Math.min(1, Math.max(0, -tx / maxScroll));

        const thumbWidth = Math.min(trackWidth, Math.round(trackWidth * (153 / 335)));
        thumb.style.width = `${thumbWidth}px`;
        const maxThumbTranslate = Math.max(0, trackWidth - thumbWidth);
        thumb.style.transform = `translateX(${progressRatio * maxThumbTranslate}px)`;
      };

      const dragLoop = () => {
        updateFromTrackPosition();
        this._progressDragRafId = requestAnimationFrame(dragLoop);
      };

      requestAnimationFrame(updateFromIndex);
      this.splideInstance.on('mounted moved resized', () => requestAnimationFrame(updateFromIndex));
      this.splideInstance.on('dragging', () => {
        if (this._progressDragRafId == null) this._progressDragRafId = requestAnimationFrame(dragLoop);
      });
      this.splideInstance.on('dragged', () => {
        if (this._progressDragRafId != null) {
          cancelAnimationFrame(this._progressDragRafId);
          this._progressDragRafId = null;
        }
        requestAnimationFrame(updateFromIndex);
      });
      this._progressResizeHandler = updateFromIndex;
      window.addEventListener('resize', this._progressResizeHandler, { passive: true });
    }

    equalizeHeights() {
      const slides = this.querySelectorAll('.splide__slide');
      if (!slides.length) return;

      const cards = this.querySelectorAll('.p3-testimonial');
      if (!cards.length) return;

      cards.forEach(card => {
        card.style.minHeight = '';
      });

      let maxHeight = 0;
      cards.forEach(card => {
        const height = card.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      cards.forEach(card => {
        card.style.minHeight = `${maxHeight}px`;
      });
    }

    disconnectedCallback() {
      if (this._progressDragRafId != null) {
        cancelAnimationFrame(this._progressDragRafId);
        this._progressDragRafId = null;
      }
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }
      if (this._progressResizeHandler) {
        window.removeEventListener('resize', this._progressResizeHandler);
        this._progressResizeHandler = null;
      }
    }
  }

  if (!customElements.get('p3-carousel-element')) {
    customElements.define('p3-carousel-element', P3CarouselElement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-form"] && !Shopify.designMode) return;
  try {
    (function() {
    var CC_MAP = {
      '1':'US/Canada','7':'Russia','20':'Egypt','27':'South Africa',
      '30':'Greece','31':'Netherlands','32':'Belgium','33':'France',
      '34':'Spain','36':'Hungary','39':'Italy','40':'Romania',
      '41':'Switzerland','43':'Austria','44':'UK','45':'Denmark',
      '46':'Sweden','47':'Norway','48':'Poland','49':'Germany',
      '51':'Peru','52':'Mexico','54':'Argentina','55':'Brazil',
      '56':'Chile','57':'Colombia','60':'Malaysia','61':'Australia',
      '62':'Indonesia','63':'Philippines','64':'New Zealand',
      '65':'Singapore','66':'Thailand','81':'Japan','82':'South Korea',
      '84':'Vietnam','86':'China','90':'Turkey','91':'India',
      '92':'Pakistan','98':'Iran','212':'Morocco','213':'Algeria',
      '216':'Tunisia','234':'Nigeria','254':'Kenya','255':'Tanzania',
      '256':'Uganda','351':'Portugal','353':'Ireland','358':'Finland',
      '380':'Ukraine','385':'Croatia','386':'Slovenia','420':'Czech Republic',
      '421':'Slovakia','506':'Costa Rica','507':'Panama','591':'Bolivia',
      '593':'Ecuador','595':'Paraguay','598':'Uruguay','852':'Hong Kong',
      '886':'Taiwan','960':'Maldives','961':'Lebanon','962':'Jordan',
      '963':'Syria','964':'Iraq','965':'Kuwait','966':'Saudi Arabia',
      '971':'UAE','972':'Israel','973':'Bahrain','974':'Qatar','977':'Nepal'
    };

    function detectCountry(digitsStr) {
      for (var len = 3; len >= 1; len--) {
        var code = digitsStr.slice(0, len);
        if (CC_MAP[code]) return { code: '+' + code, country: CC_MAP[code] };
      }
      return null;
    }

    function validatePhone(input, errorEl, hintEl) {
      var val = input.value.trim();
      if (!val) {
        errorEl.textContent = '';
        hintEl.textContent  = '';
        input.classList.remove('p3-form__input--error');
        return true;
      }
      if (/[^\d\s+\-()·.]/.test(val)) {
        errorEl.textContent = 'Phone number contains invalid characters. Use only digits, +, -, spaces, or parentheses.';
        hintEl.textContent  = '';
        input.classList.add('p3-form__input--error');
        return false;
      }
      var digits = val.replace(/\D/g, '');
      if (val.charAt(0) === '+' && digits.length > 0) {
        var detected = detectCountry(digits);
        hintEl.textContent = detected
          ? 'Detected: ' + detected.country + ' (' + detected.code + ')'
          : 'International format detected';
      } else {
        hintEl.textContent = '';
      }
      if (digits.length < 7) {
        errorEl.textContent = 'Phone number is too short (minimum 7 digits).';
        input.classList.add('p3-form__input--error');
        return false;
      }
      if (digits.length > 15) {
        errorEl.textContent = 'Phone number is too long (maximum 15 digits).';
        input.classList.add('p3-form__input--error');
        return false;
      }
      errorEl.textContent = '';
      input.classList.remove('p3-form__input--error');
      return true;
    }

    function validateRequired(input, errorEl, minLength) {
      var val = input.value.trim();
      if (!val) {
        errorEl.textContent = 'This field is required.';
        input.classList.add('p3-form__input--error');
        return false;
      }
      if (minLength && val.length < minLength) {
        errorEl.textContent = 'Please provide at least ' + minLength + ' characters (currently ' + val.length + ').';
        input.classList.add('p3-form__input--error');
        return false;
      }
      errorEl.textContent = '';
      input.classList.remove('p3-form__input--error');
      return true;
    }

    function clearFieldError(input, errorEl) {
      input.classList.remove('p3-form__input--error');
      errorEl.textContent = '';
    }

    window.p3FormCloseDialog = function() {
      var dialog  = document.getElementById('thankYouDialog');
      var overlay = document.getElementById('thankYouOverlay');
      if (dialog)  dialog.style.display  = 'none';
      if (overlay) overlay.style.display = 'none';
    };

    document.addEventListener('DOMContentLoaded', function() {
      if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
        var dialog  = document.getElementById('thankYouDialog');
        var overlay = document.getElementById('thankYouOverlay');
        if (dialog && overlay) {
          dialog.style.display  = 'flex';
          overlay.style.display = 'block';
          window.history.replaceState({}, '', window.location.pathname);
        }
      }

      var phoneInput = document.getElementById('P3ContactForm-phone');
      var phoneError = document.getElementById('P3ContactForm-phone-error');
      var phoneHint  = document.getElementById('P3ContactForm-phone-hint');
      if (phoneInput && phoneError && phoneHint) {
        phoneInput.addEventListener('input', function() {
          validatePhone(phoneInput, phoneError, phoneHint);
        });
        phoneInput.addEventListener('blur', function() {
          validatePhone(phoneInput, phoneError, phoneHint);
        });
      }

      var companyInput = document.getElementById('P3ContactForm-company');
      var companyError = document.getElementById('P3ContactForm-company-error');
      if (companyInput && companyError) {
        companyInput.addEventListener('input', function() {
          if (companyInput.value.trim()) clearFieldError(companyInput, companyError);
        });
      }

      var projectInput = document.getElementById('P3ContactForm-project');
      var projectError = document.getElementById('P3ContactForm-project-error');
      if (projectInput && projectError) {
        projectInput.addEventListener('input', function() {
          var len = projectInput.value.trim().length;
          if (len === 0) {
            projectError.textContent = '';
            projectInput.classList.remove('p3-form__input--error');
          } else if (len < 20) {
            projectError.textContent = len + ' / 20 characters minimum.';
            projectInput.classList.add('p3-form__input--error');
          } else {
            clearFieldError(projectInput, projectError);
          }
        });
      }

      var form = document.getElementById('P3ContactForm');
      if (form) {
        form.addEventListener('submit', function(e) {
          var isValid = true;

          if (phoneInput && phoneError && phoneHint) {
            if (!validatePhone(phoneInput, phoneError, phoneHint)) isValid = false;
          }
          if (companyInput && companyError) {
            if (!validateRequired(companyInput, companyError, 0)) isValid = false;
          }
          if (projectInput && projectError) {
            if (!validateRequired(projectInput, projectError, 20)) isValid = false;
          }

          if (!isValid) {
            e.preventDefault();
            var firstErr = form.querySelector('.p3-form__input--error');
            if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-testimonial"] && !Shopify.designMode) return;
  try {
    class VideoDialogController {
    constructor(button) {
      this.button = button;
      this.videoId = button.dataset.dialogVideoControl;
      this.video = document.getElementById(this.videoId);
      this.playIcon = button.querySelector('.p3-video-dialog__play-icon');
      this.pauseIcon = button.querySelector('.p3-video-dialog__pause-icon');
      this.wrapper = button.closest('[data-video-wrapper]');
      this.hideControlsTimeout = null;

      if (this.video && this.playIcon && this.pauseIcon) {
        // Ensure video starts paused
        this.video.pause();

        // Debug: track what's trying to play the video
        this.video.addEventListener('play', () => {
          console.log('Video play event fired');
          console.trace('Play triggered by:');
        }, { once: false });

        this.init();
      } else {
        console.error('Missing required elements for VideoDialogController');
      }
    }

    init() {
      console.log('Init called for video:', this.videoId);

      // Set initial state
      this.updateButtonState();

      console.log('Adding click listener to button');
      this.button.addEventListener('click', (e) => {
        console.log('Button clicked!');
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });

      // On mobile (touch devices), clicking the video plays/pauses
      this.video.addEventListener('click', (e) => {
        // Only on touch devices (no hover support)
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        }
      });

      // Show controls on video click
      this.video.addEventListener('click', () => {
        if (!this.video.paused) {
          this.showControls();
        }
      });

      // Show controls on mouse move
      this.wrapper.addEventListener('mousemove', () => {
        if (!this.video.paused) {
          this.showControls();
        }
      });

      // Update button state when video starts playing
      this.video.addEventListener('play', () => {
        this.updateButtonState();
        this.wrapper.classList.remove('show-controls');
      });

      // Update button state when video pauses
      this.video.addEventListener('pause', () => {
        this.updateButtonState();
        this.wrapper.classList.add('show-controls');
      });
    }

    updateButtonState() {
      const isPlaying = !this.video.paused && !this.video.ended && this.video.readyState > 2;
      console.log('Update button state - paused:', this.video.paused, 'ended:', this.video.ended, 'readyState:', this.video.readyState, 'isPlaying:', isPlaying);

      if (isPlaying) {
        this.playIcon.style.display = 'none';
        this.pauseIcon.style.display = 'block';
      } else {
        this.playIcon.style.display = 'block';
        this.pauseIcon.style.display = 'none';
      }
    }

    toggle() {
      const isPlaying = !this.video.paused && !this.video.ended && this.video.readyState > 2;
      console.log('Toggle called - paused:', this.video.paused, 'ended:', this.video.ended, 'readyState:', this.video.readyState, 'isPlaying:', isPlaying);

      if (isPlaying) {
        console.log('Pausing video');
        this.video.pause();
      } else {
        console.log('Playing video');
        // Unmute when user clicks play
        this.video.muted = false;
        this.video.play().catch(err => {
          console.error('Error playing video:', err);
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    const triggers = document.querySelectorAll('[data-video-trigger]');

    // Background freeze state shared across all testimonial dialogs
    // (only one dialog can be open at a time).
    let pausedBackgroundVideos = [];

    function pauseBackgroundVideos(exceptVideo) {
      pausedBackgroundVideos = [];
      document.querySelectorAll('video').forEach((v) => {
        if (v !== exceptVideo && !v.paused) {
          v.pause();
          pausedBackgroundVideos.push(v);
        }
      });
    }

    function resumeBackgroundVideos() {
      pausedBackgroundVideos.forEach((v) => {
        const playPromise = v.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
      pausedBackgroundVideos = [];
    }

    // Lock scroll without changing layout position — avoids the
    // jump-to-top / jump-back-to-bottom flash that position:fixed causes.
    function lockBodyScroll() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    triggers.forEach(trigger => {
      const videoId = trigger.dataset.videoId;
      const dialog = document.querySelector(`[data-video-dialog="${videoId}"]`);
      const video = dialog?.querySelector('video');
      const wrapper = dialog?.querySelector('[data-video-wrapper]');

      if (!dialog) return;

      trigger.addEventListener('click', () => {
        // Freeze the page: pause other videos and lock body scroll
        // so the dialog video has the user's full attention.
        pauseBackgroundVideos(video);
        lockBodyScroll();

        dialog.showModal();
        // Ensure video is paused and reset when dialog opens
        if (video) {
          video.pause();
          video.currentTime = 0;
          console.log('Dialog opened - video paused:', video.paused, 'readyState:', video.readyState);
        }
        // Show controls
        if (wrapper) {
          wrapper.classList.add('show-controls');
        }
      });

      // Close on backdrop click
      dialog.addEventListener('click', (e) => {
        // Get the video wrapper's bounding box
        const videoWrapper = wrapper;
        if (!videoWrapper) return;

        const rect = videoWrapper.getBoundingClientRect();

        // Check if click is outside the video wrapper
        const clickedOutside = (
          e.clientX < rect.left ||
          e.clientX > rect.right ||
          e.clientY < rect.top ||
          e.clientY > rect.bottom
        );

        if (clickedOutside) {
          dialog.close();
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      });

      // Close on escape key
      dialog.addEventListener('close', () => {
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        if (wrapper) {
          wrapper.classList.add('show-controls');
        }
        unlockBodyScroll();
        resumeBackgroundVideos();
      });
    });

    // Initialize video controls
    const videoControls = document.querySelectorAll('[data-dialog-video-control]');
    console.log('Found video control buttons:', videoControls.length);
    videoControls.forEach(button => {
      console.log('Initializing controller for button:', button);
      new VideoDialogController(button);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
